import TextInputState from '../TextInputState';

var dismissKeyboard = function dismissKeyboard() {
  TextInputState.blurTextInput(TextInputState.currentlyFocusedField());
};

export default dismissKeyboard;